import { render, staticRenderFns } from "./ActivityRules.vue?vue&type=template&id=a76bfb18&scoped=true"
import script from "./ActivityRules.vue?vue&type=script&lang=js"
export * from "./ActivityRules.vue?vue&type=script&lang=js"
import style0 from "./ActivityRules.vue?vue&type=style&index=0&id=a76bfb18&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76bfb18",
  null
  
)

export default component.exports